import React, { useState } from "react";
import { Button } from "newui/components/Button";
import { OtpInput } from "newui/components/ui/OtpInput";

const TOTP_DIGIT_COUNT = 6;
const TOTP_CODE_PATTERN = /^\d{6}$/;

export interface TotpConfirmStepProps {
	error?: string;
	isSubmitting: boolean;
	onSubmit: (code: string) => void;
}

export const TotpConfirmStep = ({ error, isSubmitting, onSubmit }: TotpConfirmStepProps) => {
	const [code, setCode] = useState("");

	const isValid = TOTP_CODE_PATTERN.test(code);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (isValid) {
			onSubmit(code);
		}
	};

	return (
		<form onSubmit={handleSubmit} className="flex flex-col gap-4">
			<p className="font-roboto text-sm text-gray-600">
				Enter the 6-digit code from your authenticator app.
			</p>
			<OtpInput
				digitCount={TOTP_DIGIT_COUNT}
				value={code}
				onChange={setCode}
				disabled={isSubmitting}
				error={error}
				// Auto-focus the first box so the user can start typing the
				// authenticator code immediately (PRO-731 follow-up). Mirrors the
				// TOTP login challenge (TwoFactorChallenge), which sets this for the
				// same reason — clipboard sniffing and mount-time autofocus are
				// mutually exclusive in OtpInput, and a code read off an
				// authenticator app is typed, not pasted from the clipboard.
				useClipboardSniff={false}
			/>
			<Button
				type="submit"
				btntype="primary"
				disabled={!isValid || isSubmitting}
				isLoading={isSubmitting}
				data-testid="confirm-totp-btn"
			>
				Confirm
			</Button>
		</form>
	);
};
